module.exports = __webpack_public_path__ + "img/menu-profiel.8deec58c.png";